import { Message } from '../../MessageBus/Message';


export class DropCommand extends Message
{
    constructor(Folder: string)
    {
        super("Drop", { Folder });
    }
}
